import type { LiteClient, SearchParamsObject, SearchResponse } from 'algoliasearch/lite'

/**
 * Compat wrapper reproducing the legacy algoliasearch v3 index object
 * (`{ indexName, search(query, params) }`) on top of the v5 lite client.
 *
 * It lets the v3 → v5 migration stay iso-behaviour: every consumer that used to
 * call `index.search(query, params)` keeps the exact same call shape and still
 * gets a `{ hits, nbHits, facets, ... }` response — only the creation point
 * changes. Internally the single-index query is issued through the v5
 * `searchForHits` helper, whose first (and only) result is returned.
 */
export interface ProductIndex {
  readonly indexName: string
  search<THit = Record<string, unknown>>(
    query: string,
    params?: SearchParamsObject,
  ): Promise<SearchResponse<THit>>
}

export function createProductIndex(client: LiteClient, indexName: string): ProductIndex {
  return {
    indexName,
    search<THit = Record<string, unknown>>(query: string, params: SearchParamsObject = {}) {
      return client
        .searchForHits<THit>({ requests: [{ indexName, query, ...params }] })
        .then(({ results }) => results[0]!)
    },
  }
}
